import React from "react";
import { toast } from "react-toastify";
import { CardHeader, Input, InputGroup } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { AddTask, ToDoPlaceholder } from "../../../Constant";
import { useAppDispatch, useAppSelector } from "../../../Redux-Toolkit/Hooks";
import { addNewTodo, setTask } from "../../../Redux-Toolkit/Reducers/ToDoSlice";

export const ToDoHeader = () => {
  const {task} = useAppSelector((state)=>state.todo)
  const dispatch=useAppDispatch()

  const handleNewTask = () => {
    if (task === "") {
      toast.error("please add your todo");
    } else {
      dispatch(addNewTodo(task));
      dispatch(setTask(" "));
    }
  };

  const onTaskChanged = (e:React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setTask(e.currentTarget.value));
  };

  return (
    <CardHeader className="b-bottom card-no-border pb-0">
      <div className="todo-list-header">
        <InputGroup className="new-task-wrapper">
          <Input value={task} placeholder={ToDoPlaceholder} id="new-task" onChange={(e)=>onTaskChanged(e)} />
          <Btn color="primary" className="add-new-task-btn" onClick={handleNewTask}>{AddTask}</Btn>
        </InputGroup>
      </div>
    </CardHeader>
  );
};
